"use strict";

exports.__esModule = true;
exports.ButtonLink = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = require("./Button");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StyledLink = _Button.StyledButton.withComponent('a', process.env.NODE_ENV === "production" ? {
  target: "e1q203mn0"
} : {
  target: "e1q203mn0",
  label: "StyledLink"
});
var ButtonLink = function ButtonLink(_ref) {
  var label = _ref.label,
    outlineColor = _ref.outlineColor,
    fill = _ref.fill,
    to = _ref.to,
    target = _ref.target,
    rel = _ref.rel,
    leadingIcon = _ref.leadingIcon,
    size = _ref.size,
    trailingIcon = _ref.trailingIcon,
    variant = _ref.variant;
  return (0, _jsxRuntime.jsxs)(StyledLink, {
    href: to,
    target: target ? target : '_self',
    rel: rel,
    fill: fill,
    outlineColor: outlineColor,
    size: size,
    variant: variant,
    hasLinkStyles: true,
    children: [leadingIcon && (0, _jsxRuntime.jsx)(_Button.LeadingIcon, {
      children: leadingIcon
    }), label, trailingIcon && (0, _jsxRuntime.jsx)(_Button.TrailingIcon, {
      children: trailingIcon
    })]
  });
};
exports.ButtonLink = ButtonLink;
ButtonLink.propTypes = {
  label: _propTypes.default.string.isRequired,
  fill: _propTypes.default.string,
  target: _propTypes.default.oneOf(['_self', '_blank', '_parent', '_top']),
  to: _propTypes.default.string.isRequired,
  rel: _propTypes.default.string,
  leadingIcon: _propTypes.default.node,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  trailingIcon: _propTypes.default.node,
  variant: _propTypes.default.oneOf(['primary', 'primary-basic', 'secondary', 'outlined', 'text'])
};
ButtonLink.defaultProps = {
  size: 'medium',
  variant: 'primary'
};